<template>

    <v-dialog v-model="model" persistent max-width="900">

        <v-card>
            <v-img :src="cdnBaseUrl('/img/application_update.png')"></v-img>

            <div class="overlay-close">

                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="closeDialog" v-on="on" icon color="white">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close this dialog</span>
                </v-tooltip>
            </div>

            <v-sheet color="transparent" class="overlay-box text-h3">
                BUILD {{ adjustedBuildNumber }}
            </v-sheet>

            <div class="overlay-button">
                <v-btn color="primary" @click="applyClicked" :loading="loading">RELOAD AND APPLY</v-btn>
            </div>
        </v-card>

    </v-dialog>

</template>

<script>

export default {

    name: "ApplicationUpdatedDialog",

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        build: {
            required: true,
            type: Number,
        }
    },

    data() {
        return {
            loading: false
        }
    },

    computed: {

        adjustedBuildNumber() {
            return this.build + 1200;
        },

        model: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },
    },

    methods: {

        applyClicked() {
            this.loading = true;
            this.sendToUrl(window.location.href);
        },

        closeDialog() {
            this.$emit('input', false);
        },
    }
}

</script>

<style scoped>

.overlay-box {
    position: absolute;
    top: 110px;
    right: 120px;
    color: #b0ddf3;
    width: 300px;
    text-align: center;
}

.overlay-button {
    position: absolute;
    top: 280px;
    right: 180px;
}

.overlay-close {
    position: absolute;
    top: 20px;
    right: 20px;
}
</style>